const feedbackCard = {
  title: 'Comentarios',
  by: 'Por:',
  phone: 'Teléfono:',
  via: 'vía',
  notes: 'Notas',
  submit: 'Agregar comentario',
  source: {
    CrewLink: 'CrewLink',
    QR: 'QR',
    TripCard: 'Tarjeta de viaje',
  },
};

export default feedbackCard;
